import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import tplHelpers from "../../../helpers/tpl";
import ThirdPartyLogisticsASNForm from './ThirdPartyLogisticsASNForm';
import ThirdPartyLogisticsASNTable from './ThirdPartyLogisticsASNTable';

function ThirdPartyLogisticsASN(props) {

    const [warehouse, setWarehouse] = useState("");
    const [orderNbr, setOrderNbr] = useState("");
    const [trOrder, setTrOrder] = useState("");

    const warehouse_options = [
        {value: 10, name: 'Geodis'}
    ];

    useEffect(() => {
        setTrOrder("");
    }, [orderNbr, warehouse]);

    const getAcumaticaTransferOrder = async() => {
        props.setLoading(true);
        try {
            const formattedAcuNumber = formatAcuOrderNum(orderNbr);
            const res = await tplHelpers.getAcumaticaTransferOrder(formattedAcuNumber, warehouse, props.company, props.token);
            if (!res?.TransferOrdersDetails?.length) {
                props.toast.error("Could not find transfer order ", orderNbr);
                return;
            };
            const formatted_order = formatTransferOrder(res.OrderNbr.value, res.ToWarehouse.value, res.TransferOrdersDetails);
            setTrOrder(formatted_order);
        } catch (err) {
            console.log('getAcumaticaTransferOrder Error: ', err);
        } finally {
            props.setLoading(false);
        };
    };

    const formatTransferOrder = (acu_order_num, warehouse, items) => {
        let formatted = {
            acu_order_num: acu_order_num,
            warehouse: warehouse,
            total_shipped: 0,
            total_ordered: 0,
            items: []
        };

        for (let item of items) {
            formatted.items.push({
                OrderNbr: acu_order_num,
                ShipmentNbr: item.ShipmentNbr?.value,
                Sku: item.InventoryID?.value,
                Description: item.Description?.value,
                OrderedQty: item.Quantity?.value,
                Qty: item.QtyOnShipments?.value,
                id: item.rowNumber
            });
            formatted.total_ordered += item.Quantity?.value;
            formatted.total_shipped += item.QtyOnShipments.value;
        };
        return formatted;  
    };

    const formatAcuOrderNum = (acuOrderNum) => {
        while (acuOrderNum.length < 7) {
            acuOrderNum = '0' + acuOrderNum;
        };
        return acuOrderNum;
    };

    const sendASN = async () => {
        props.setLoading(true);
        try {
            if (warehouse === 10) {
                const res = await tplHelpers.sendGeodisAsn(trOrder, props.company, props.token);
                if (res.success) {
                    props.toast.success("ASN Sent");
                    setTrOrder("");
                    setOrderNbr("");
                    setWarehouse("");
                } else {
                    props.toast.error("Failed to send ASN");
                }
            } else {
                props.toast.error('Cannot send ASN.');
            }
        } catch (err) {
            console.log(err);
        } finally {
            props.setLoading(false);
        }
    };

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>3PL Advanced Ship Notice</h1> 
                <p>Enter the Transfer Order Number that is ready to be shipped to the 3PL.</p>
                <ThirdPartyLogisticsASNForm
                    warehouse_options = {warehouse_options}
                    warehouse = {warehouse}
                    setWarehouse = {setWarehouse}
                    orderNbr = {orderNbr}
                    setOrderNbr = {setOrderNbr}
                    getAcumaticaTransferOrder = {getAcumaticaTransferOrder}
                 />
                { trOrder ?
                    <Box display = "flex" flexWrap = "wrap" gap = {2} sx = {{mt: '20px'}}>
                        <Box>
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Transfer Order Number:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.acu_order_num}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box >
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Total Quantity on Order:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.total_ordered}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box >
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Total Shipped Quantity:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.total_shipped}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <ThirdPartyLogisticsASNTable
                            loading = {props.isLoading}
                            items = {trOrder.items}
                            sendASN = {sendASN}
                            warehouse_options = {warehouse_options}
                            warehouse = {warehouse}
                        />
                    </Box>
                : null }
            </Box>
        </Box>
    )
}

export default ThirdPartyLogisticsASN;